<div id="partition-input">
  <div class="input-wrapper">
    <input *ngFor="let item of otpArray; let index=index" id="codeBox{{index+1}}" type="text" maxlength="1"
      [(ngModel)]="otpArray[index].value" (ngModelChange)="goNext(index)" inputmode="numeric">
  </div>
</div>